import styled from 'styled-components';

export const GalleryPageContainer = styled.div`
  background-color: #d4af37;
  color: #000000;
`;

export const Section = styled.section`
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
`;

export const SectionTitle = styled.h2`
  margin: 0 0 16px;
  font-size: 1.6rem;
`;

export const TextBlock = styled.div`
  font-size: 0.95rem;
  line-height: 1.6;
`;

export const GalleryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media (max-width: 800px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 500px) {
    grid-template-columns: 1fr;
  }
`;

export const GalleryCard = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 0.9rem;
`;

export const GalleryTitle = styled.div`
  font-weight: 600;
  margin-top: 6px;
`;

export const GalleryMeta = styled.div`
  font-size: 0.8rem;
  color: #555555;
  margin-top: 4px;
`;

export const GalleryDescription = styled.div`
  font-size: 0.85rem;
  margin-top: 4px;
`;
